import React from 'react';
import './KioskoComponents.css';

const TecladoNumerico = ({ onKeyPress, onClear, onEnter }) => {
    const keys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', 'Borrar', '0', 'Enter'];

    const handleClick = (key) => {
        if (key === 'Borrar') onClear();
        else if (key === 'Enter') onEnter();
        else onKeyPress(key);
    };

    return (
        <div className="teclado-kiosko">
            {keys.map((key) => (
                <button
                    key={key}
                    className={`tecla-kiosko ${isNaN(key) ? 'tecla-accion' : ''} ${key === 'Enter' ? 'tecla-enter' : ''}`}
                    onClick={() => handleClick(key)}
                >
                    {key === 'Borrar' ? '←' : key}
                </button>
            ))}
        </div>
    );
};

export default TecladoNumerico;
